import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  StatusServerlessTask,
  StatusServerlessTaskLabel,
} from '@/service/serverless-gpu/type';

const BadgeTaskStatus = ({ status }: { status: StatusServerlessTask }) => {
  return (
    <Badge
      variant={'secondary'}
      className={cn(
        [StatusServerlessTask.ComplateSuccess, StatusServerlessTask.Completed].includes(status) &&
          'bg-success/10 text-success',
        [
          StatusServerlessTask.ComplateFailed,
          StatusServerlessTask.ComplateTimeout,
          StatusServerlessTask.IncompleteCancel,
          StatusServerlessTask.FailedInvalidSyntax,
          StatusServerlessTask.FailedUnexpectedIndent,
          StatusServerlessTask.FailedNameError,
          StatusServerlessTask.FailedSyntaxError,
          StatusServerlessTask.FailedNoModuleNamed,
        ].includes(status) && 'bg-destructive/10 text-destructive',
        status === StatusServerlessTask.Running && 'bg-warning/10 text-warning',
        status === StatusServerlessTask.ReachedBudgetLimit &&
          'bg-purple-500 text-purple-800',
      )}
    >
      {StatusServerlessTaskLabel[status] || status}
    </Badge>
  );
};

export default BadgeTaskStatus;
